export type ReleaseEntryKind = "feature" | "improvement" | "fix"

export interface ReleaseEntry {
    kind: ReleaseEntryKind
    title: string
    description: string
}

export interface Release {
    /** Bump this to re-show the modal to everyone after the next release. */
    version: string
    date: string
    /** The one change worth leading with. Gets the hero treatment. */
    headline: {
        title: string
        description: string
        href?: string
        cta?: string
    }
    entries: ReleaseEntry[]
}

export const CURRENT_RELEASE: Release = {
    version: "2026.08.16",
    date: "August 16, 2026",
    headline: {
        title: "Study Planner",
        description:
            "Tell us your target score, exam date and how strong you feel in each domain — we'll lay out every practice session between now and exam day, weighted toward what you actually need. Blocks tick themselves off as you practise.",
        href: "/dashboard/planner",
        cta: "Open Study Planner",
    },
    entries: [
        {
            kind: "feature",
            title: "Custom themes",
            description:
                "Switch the whole app between curated colour themes from the header — light, dark and everything in between.",
        },
        {
            kind: "feature",
            title: "Plan around your life",
            description:
                "Add note-only blocks to any day for tutor sessions, rest days or essay deadlines — no question target required.",
        },
        {
            kind: "improvement",
            title: "Community reads properly on mobile",
            description:
                "Doubt cards no longer run off the edge of the screen, and long domain and skill tags stay inside their pills instead of spilling out.",
        },
        {
            kind: "improvement",
            title: "Roomier question discussions",
            description:
                "Headings, buttons and reply threads now reflow on small screens, so nested replies keep their width instead of being squeezed away.",
        },
        {
            kind: "fix",
            title: "Practice links from your plan always resolve",
            description:
                "Every skill the planner schedules is one that actually has questions behind it, so starting a session never lands on an empty page.",
        },
    ],
}
